<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M20.7879 5.02499C20.905 4.90783 20.905 4.71788 20.7879 4.60072L19.3993 3.21213C19.2821 3.09497 19.0922 3.09497 18.975 3.21213L12 10.1871L5.02499 3.21213C4.90783 3.09497 4.71788 3.09497 4.60072 3.21213L3.21213 4.60072C3.09497 4.71788 3.09497 4.90783 3.21213 5.02499L10.1871 12L3.21213 18.975C3.09497 19.0922 3.09497 19.2821 3.21213 19.3993L4.60072 20.7879C4.71788 20.905 4.90783 20.905 5.02499 20.7879L12 13.8129L18.975 20.7879C19.0922 20.905 19.2821 20.905 19.3993 20.7879L20.7879 19.3993C20.905 19.2821 20.905 19.0922 20.7879 18.975L13.8129 12L20.7879 5.02499Z" fill="currentColor"/>
	</svg>
</template>

<script>
  export default {};
</script>
